export class CaiModel {
	A: CaiConditionModel;
	B: CaiConditionModel;
	driver_side?: string;
}

export class CaiConditionModel {
	condition_1: boolean;
	condition_2: boolean;
	condition_3: boolean;
	condition_4: boolean;
	condition_5: boolean;
	condition_6: boolean;
	condition_7: boolean;
	condition_8: boolean;
	condition_9: boolean;
	condition_10: boolean;
	condition_11: boolean;
	condition_12: boolean;
	condition_13: boolean;
	condition_14: boolean;
	condition_15: boolean;
	condition_16: boolean;
	condition_17: boolean;
}
